import React from 'react';
import { Target, TrendingUp, CheckCircle, Flag } from 'lucide-react';

function Header({ stats }) {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <div className="logo-icon">
            <Target size={24} />
          </div>
          <h1>Milestone<span>Map</span></h1>
        </div>

        <div className="header-stats">
          <div className="stat-item">
            <div className="stat-value">{stats.totalGoals}</div>
            <div className="stat-label">活跃目标</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">{stats.completedMilestones}/{stats.totalMilestones}</div>
            <div className="stat-label">里程碑</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">{stats.overallProgress}%</div>
            <div className="stat-label">总进度</div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
